<template>
    <div :class="['update-score-wrapper', { 'edit-mode': isEditMode }]">
        <div class="loading" v-if="fetchData">
            <load-data />
        </div>
        <b-col class="m-2" v-if="courseLabs.length">
            <div class="mt-4" v-for="(courseLab, reindex) in courseLabs" :key="courseLab.id || reindex">
                <div v-if="courseLab.type === type">
                    <b-col v-if="evaluationLabActivity">

                        <!-- ===== TOP ACTION BAR ===== -->
                        <b-col class="d-flex align-items-center justify-content-between mb-2">
                            <!-- LEFT ACTIONS -->
                            <div class="d-flex align-items-center">


                                <!-- Edit Icon -->
                                <i v-if="!isEditMode" class="fas fa-edit text-info ml-1 mr-2" v-b-tooltip.hover
                                    title="Edit" @click="enableEdit"
                                    style="font-size: 18px!important; cursor: pointer;"></i>

                                <!-- Import Excel -->
                                <import-excel v-if="isEditMode && evaluationLabActivity.type == 'lab'"
                                    :students="students" :headers="evaluationTableHeaderRow"
                                    @imported="applyExcelData" />
                            </div>

                            <!-- RIGHT ACTIONS -->
                            <div v-if="isEditMode" class="d-flex align-items-center">
                                <b-button size="sm" variant="success" @click="saveEdit">
                                    Save
                                </b-button>

                                <b-button size="sm" variant="secondary" class="ml-2" @click="cancelEdit">
                                    Cancel
                                </b-button>
                            </div>
                        </b-col>
                        <table class="table  table-striped table-bordered">
                            <thead v-if="labInternalExamEvaluationType == 'multiple_experiments'"
                                style=" position: sticky; top: 0;  background-color: gray; ">
                                <tr>
                                    <th rowspan="2">{{ studentListOrder === 'enrollment_no' ? 'Enrollment No.' : studentListOrder === 'admission_number' ? 'Admission No.' : studentListOrder === 'register_number' ? 'Register No.' : 'Roll No.' }}</th>
                                    <th rowspan="2">Student</th>
                                    <th v-for="(labExperiment, expindex) in labExperiments" :key="expindex"
                                        :colspan="enabledLabHeaders.length + 2">
                                        <span v-b-tooltip.hover :title="labExperiment.no +
                                            '. ' +
                                            labExperiment.name +
                                            ': ' +
                                            labExperiment.description
                                            ">{{ labExperiment.no }}.
                                            {{ labExperiment.name.substring(0, 15) }}<br>
                                            {{labExperiment["course_outcomes"].map(co => co.code).join(', ')}}</span>
                                    </th>
                                    <th rowspan="2">Avg</th>
                                </tr>
                                <tr>
                                    <th v-for="(header, headindex) in evaluationTableHeaderRow" :key="headindex">
                                        <span v-if="header.type == 'date'">{{ evaluationLabActivity.type ==
                                            'lab' ? 'Date' : '' }}</span>
                                        <span v-else>{{ header.name }}-{{ header.max_score }}</span>
                                    </th>
                                </tr>
                            </thead>
                            <thead
                                v-if="(labInternalExamEvaluationType == 'single_experiment' && labExperiments.length > 0)"
                                style=" position: sticky; top: 0;  background-color: gray; ">
                                <tr>
                                    <th rowspan="2">{{ studentListOrder === 'enrollment_no' ? 'Enrollment No.' : studentListOrder === 'admission_number' ? 'Admission No.' : studentListOrder === 'register_number' ? 'Register No.' : 'Roll No.' }}</th>
                                    <th rowspan="2">Student</th>
                                    <th :colspan="enabledLabHeaders.length">
                                        Experiments score
                                    </th>
                                </tr>
                                <tr>
                                    <th v-for="(enabledLabHeader, headindex) in enabledLabHeaders" :key="headindex">
                                        {{ evaluationTableHeaderRow[headindex].name }}-{{
                                            evaluationTableHeaderRow[headindex].max_score }}
                                    </th>
                                </tr>
                            </thead>

                            <tbody v-if="labInternalExamEvaluationType == 'multiple_experiments'">
                                <tr v-for="(student, studindex) in students" :key="studindex">
                                    <th class="fixed-table-column">{{ studentListOrder === 'enrollment_no' ? student.enrollment_no : studentListOrder === 'admission_number' ? student.admission_no : studentListOrder === 'register_number' ? student.register_no : student.roll_number }}</th>
                                    <th class="fixed-table-column">
                                        {{ student.first_name }} {{ student.last_name }}
                                    </th>
                                    <td v-for="(evaluationHeader,
                                        headindex) in evaluationTableHeaderRow" :key="headindex"
                                        style="min-width: 60px;">
                                        <small style="font-size: 10px !important;"
                                            v-if="evaluationHeader.type == 'date' && evaluationLabActivity.type == 'lab'">
                                            {{ formatDate(evaluationTableDates[student.institution_user_id][
                                                evaluationHeader.experiment_id
                                            ]) }}
                                        </small>
                                        <span v-if="evaluationHeader.type == 'date'">
                                            <b-form-input :disabled="!isEditMode"
                                                v-if="evaluationLabActivity.type == 'lab'"
                                                style="width: 18px; padding: 0px;" v-model="evaluationTableDates[student.institution_user_id][
                                                    evaluationHeader.experiment_id
                                                ]" type="date" placeholder="Choose score">
                                            </b-form-input>
                                        </span>
                                        <b-form-input :disabled="!isEditMode" v-if="evaluationHeader.type == null"
                                            v-model="evaluationTableData[student.institution_user_id][
                                                evaluationHeader.experiment_id
                                            ][evaluationHeader.id]
                                                " type="number" :max="evaluationHeader.max_score"
                                            placeholder="Enter score"
                                            @blur="handleScoreEntry(student.institution_user_id, evaluationHeader.experiment_id, evaluationHeader.id)">
                                        </b-form-input>
                                        <span v-if="evaluationHeader.type == 'total'">{{
                                            totalScores[student.institution_user_id][evaluationHeader.experiment_id] ?
                                                parseFloat(totalScores[student.institution_user_id][evaluationHeader.experiment_id]).toFixed(2)
                                                : '' }}
                                        </span>
                                    </td>
                                    <th class="fixed-table-column">
                                        {{ avarage[student.institution_user_id] ?
                                            parseFloat(avarage[student.institution_user_id]).toFixed(2) : '' }}
                                    </th>
                                </tr>
                            </tbody>
                            <tbody
                                v-if="(labInternalExamEvaluationType == 'single_experiment' && labExperiments.length > 0)">
                                <tr v-for="(student, studindex) in students" :key="studindex">
                                    <th class="fixed-table-column">{{ studentListOrder === 'enrollment_no' ? student.enrollment_no : studentListOrder === 'admission_number' ? student.admission_no : studentListOrder === 'register_number' ? student.register_no : student.roll_number }}</th>
                                    <th class="fixed-table-column">
                                        {{ student.first_name }} {{ student.last_name }}
                                    </th>
                                    <td v-for="(enabledLabHeader, headindex) in enabledLabHeaders" :key="headindex"
                                        style="min-width: 60px;">
                                        <b-form-input :disabled="!isEditMode" v-model="evaluationTableData[student.institution_user_id][
                                            evaluationTableHeaderRow[0].experiment_id
                                        ][evaluationTableHeaderRow[headindex].id]"
                                            @blur="handleScoreEntry(student.institution_user_id, evaluationTableHeaderRow[0].experiment_id, evaluationTableHeaderRow[headindex].id)"
                                            type="number" :max="evaluationTableHeaderRow[headindex].max_score"
                                            placeholder="Enter score">
                                        </b-form-input>
                                    </td>
                                </tr>
                            </tbody>
                        </table>


                        <b-col class="d-flex align-items-center justify-content-end mb-2">

                            <div v-if="isEditMode" class="d-flex align-items-center">
                                <b-button size="sm" variant="success" @click="saveEdit">
                                    Save
                                </b-button>

                                <b-button size="sm" variant="secondary" class="ml-2" @click="cancelEdit">
                                    Cancel
                                </b-button>
                            </div>

                        </b-col>


                    </b-col>


                </div>
            </div>
        </b-col>
    </div>
</template>

<script>
import ImportExcel from "./ImportExcel.vue";

import axios from "axios";
import Vue from 'vue';
import moment from 'moment'; // Import moment.js
export default {
    props: ["course_id", "type"],
    async created() {
        await this.getCourseLabs();
        await this.getLabExperiments();
        if (this.courseLabs.length == 0) {
            return;
        }
        await this.getLabEvaluationOptions();
        await this.labEvaluationTable(this.courseLabs[0])
    },
    components: {
        ImportExcel
    },

    data() {
        return {
            isEditMode: false,
            enteredScores: new Set(),
            createButtonEnable: true,
            viewImportExcelModel: false,
            importExcelFile: null,
            excelImportStatus: "",
            totalScores: {}, // processed on updateTotalMarks computed proprty
            avarage: {},
            fetchData: false,
            copy_from: '',
            courseLabs: [],
            courseLabsLoaded: false,
            labExperiments: [],
            labEvaluationOptions: {
                lab: {
                    Practical: { id: "", enable: false, score: "", no: "" },
                    Record: { id: "", enable: false, score: "", no: "" },
                    Viva: { id: "", enable: false, score: "", no: "" },
                    Algorithm: { id: "", enable: false, score: "", no: "" },
                    Program: { id: "", enable: false, score: "", no: "" },
                    Output: { id: "", enable: false, score: "", no: "" },

                    LabWork: { id: "", enable: false, score: "", no: "" },
                    ObservationAndResult: { id: "", enable: false, score: "", no: "" },
                    AimAndProcedure: { id: "", enable: false, score: "", no: "" },
                    OpenEndedExperiment: { id: "", enable: false, score: "", no: "" },

                    Knowledge: { id: "", enable: false, score: "", no: "" },
                    Experiment: { id: "", enable: false, score: "", no: "" },
                    Documentation: { id: "", enable: false, score: "", no: "" },
                    SafetyAndCleanup: { id: "", enable: false, score: "", no: "" },
                    ToolsAndEquipment: { id: "", enable: false, score: "", no: "" },
                    Procedure: { id: "", enable: false, score: "", no: "" },
                    DataAndResult: { id: "", enable: false, score: "", no: "" },
                    LabRecordAndGithub: { id: "", enable: false, score: "", no: "" },
                    TimelyCompletionOfTask: { id: "", enable: false, score: "", no: "" },

                    ClassViva: { id: "", enable: false, score: "", no: "" },
                    Exam: { id: "", enable: false, score: "", no: "" },
                    WrittenExam: { id: "", enable: false, score: "", no: "" },

                    PresentationAndPreLabWork: { id: "", enable: false, score: "", no: "" },
                    PreparationAndPreLabWork: { id: "", enable: false, score: "", no: "" },
                    ConductOfExperiment: { id: "", enable: false, score: "", no: "" },
                    LabReportAndRecordKeeping: { id: "", enable: false, score: "", no: "" },

                    CourseProject: { id: "", enable: false, score: "", no: "" },
                    PreliminaryWork: { id: "", enable: false, score: "", no: "" },
                    ImplementingTheWork: { id: "", enable: false, score: "", no: "" },
                    Performance: { id: "", enable: false, score: "", no: "" },
                },
                internal_exam: {
                    Practical: { id: "", enable: false, score: "", no: "" },
                    Record: { id: "", enable: false, score: "", no: "" },
                    Viva: { id: "", enable: false, score: "", no: "" },
                    Algorithm: { id: "", enable: false, score: "", no: "" },
                    Program: { id: "", enable: false, score: "", no: "" },
                    Output: { id: "", enable: false, score: "", no: "" },

                    LabWork: { id: "", enable: false, score: "", no: "" },
                    ObservationAndResult: { id: "", enable: false, score: "", no: "" },
                    AimAndProcedure: { id: "", enable: false, score: "", no: "" },
                    OpenEndedExperiment: { id: "", enable: false, score: "", no: "" },

                    Knowledge: { id: "", enable: false, score: "", no: "" },
                    Experiment: { id: "", enable: false, score: "", no: "" },
                    Documentation: { id: "", enable: false, score: "", no: "" },
                    SafetyAndCleanup: { id: "", enable: false, score: "", no: "" },
                    ToolsAndEquipment: { id: "", enable: false, score: "", no: "" },
                    Procedure: { id: "", enable: false, score: "", no: "" },
                    DataAndResult: { id: "", enable: false, score: "", no: "" },
                    LabRecordAndGithub: { id: "", enable: false, score: "", no: "" },
                    TimelyCompletionOfTask: { id: "", enable: false, score: "", no: "" },

                    ClassViva: { id: "", enable: false, score: "", no: "" },
                    Exam: { id: "", enable: false, score: "", no: "" },
                    WrittenExam: { id: "", enable: false, score: "", no: "" },

                    PresentationAndPreLabWork: { id: "", enable: false, score: "", no: "" },
                    PreparationAndPreLabWork: { id: "", enable: false, score: "", no: "" },
                    ConductOfExperiment: { id: "", enable: false, score: "", no: "" },
                    LabReportAndRecordKeeping: { id: "", enable: false, score: "", no: "" },

                    CourseProject: { id: "", enable: false, score: "", no: "" },
                    PreliminaryWork: { id: "", enable: false, score: "", no: "" },
                    ImplementingTheWork: { id: "", enable: false, score: "", no: "" },
                    Performance: { id: "", enable: false, score: "", no: "" },
                },


            },
            editLabHeaders: false,
            updateExperimentButton: "save",
            enableLabAssessmentEvaluation: false,
            enableLabInternalExamEvaluation: false,
            enableLabRecordEvaluation: false,
            labInternalExamEvaluationType: 'single_experiment', // 'multiple_experiments', 'single_experiment'
            enableLabVivaVoceEvaluation: false,
            updateLabEvaluationButton: "Save",
            students: [],
            evaluationLabActivity: null,
            enabledLabHeaders: [],
            evaluationTableHeaderRow: [],
            evaluationTableDates: {},
            evaluationTableData: {},
            courseOutcomes: [],
            courseOutcomeOptions: [],
        };
    },
    methods: {
        enableEdit() {
            this.isEditMode = true;
        },

        async saveEdit() {
            await this.updateLabEvaluation(false);
            this.isEditMode = false;
        },

        cancelEdit() {
            this.isEditMode = false;
            this.$toast.info("Edit cancelled");
        },
        handleScoreEntry(studentId, experiment_id, header_id) {
            this.updateTotalMarks(studentId, experiment_id, header_id);
            const key = `${studentId}-${experiment_id}-${header_id}`;
            this.enteredScores.add(key);
            if (this.enteredScores.size >= 20) {
                this.updateLabEvaluation(true);// autoUpdateEvent = true
                this.enteredScores = new Set(); // Reset enteredScores
            }
        },
        formatDate(date) {
            // If the date is empty or not valid, return an empty string
            if (!date) return '';

            // Format the date in dd/mm/yyyy format using moment.js
            return moment(date).format('DD/MM/YYYY');
        },
        applyExcelData(importedData) {
            importedData.forEach(item => {
                if (item.type === "date") {
                    this.$set(
                        this.evaluationTableDates[item.student_id],
                        item.experiment_id,
                        item.value
                    );
                } else {
                    this.$set(
                        this.evaluationTableData[item.student_id][item.experiment_id],
                        item.header_id,
                        item.value
                    );
                    this.updateTotalMarks(item.student_id, item.experiment_id);
                }
            });

            this.$toast.success("Scores applied to table");
        },

        // Helper function to handle date values
        handleDateValue(excelValue, rowIndex, colIndex, institution_user_id, experiment_id) {
            let parsedDate;
            // Handle string dates in dd/mm/yyyy format
            parsedDate = moment(excelValue, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
            // Check if the date is valid
            if (!moment(parsedDate, 'YYYY-MM-DD', true).isValid()) {
                throw new Error(`Invalid date format at Row ${rowIndex + 1}, Column ${colIndex + 1}.`);
            }
            // Save the parsed date in the evaluation table
            this.$set(
                this.evaluationTableDates[institution_user_id],
                experiment_id,
                parsedDate
            );
        },

        // Helper function to handle score values
        handleScoreValue(excelValue, institution_user_id, experiment_id, headerId) {
            this.$set(
                this.evaluationTableData[institution_user_id][experiment_id],
                headerId,
                parseFloat(excelValue)
            );
            this.updateTotalMarks(institution_user_id, experiment_id);
        },

        updateTotalMarks(student_id, experiment_id) {
            let scores = this.evaluationTableData[student_id]?.[experiment_id];
            if (!scores) {
                this.totalScores[student_id][experiment_id] = 0;
                this.avarage[student_id] = 0;
                return;
            }
            // Convert scores object to array and calculate total marks for the experiment
            const scoresArray = Object.keys(scores).map(key => [Number(key), scores[key]]);
            this.totalScores[student_id][experiment_id] = scoresArray.reduce((sum, score) => {
                return sum + (!isNaN(score[1]) ? Number(score[1]) : 0);
            }, 0);

            // Calculate total scores across all experiments for the student
            const total = this.totalScores[student_id];
            const totalArray = Object.keys(total).map(key => [Number(key), total[key]]);
            const totalScoresSum = totalArray.reduce((sum, score) => {
                return sum + (!isNaN(score[1]) ? Number(score[1]) : 0);
            }, 0);
            // Divide by the fixed total number of experiments, not how many
            // have been touched so far - otherwise the average changes
            // depending on the order fields are visited instead of the scores.
            const experimentCount = this.labExperiments.length;
            this.avarage[student_id] = experimentCount ? totalScoresSum / experimentCount : 0;
        },
        handleStudExperimentDateChange(studId, expId) {
            document.getElementById('studExperimentDatePicker' + studId + expId).click();
        },
        propertyCopyCompleted() {
            this.$bvModal.hide('copyCoursePropertiesModel');
            this.getLabExperiments();
        },
        async getCourseLabs() {
            this.createButtonEnable = true;
            this.fetchData = true;
            const url =
                this.$store.getters.getAPIKey.mainAPI +
                `/labactivities?course=${this.course_id}`;
            await axios
                .get(url)
                .then((response) => {
                    this.courseLabs = response.data;
                    this.courseLabs = response.data.filter(l => l.type === this.type);
                    this.fetchData = false;
                })
                .catch(() => {
                    this.fetchData = false;
                });
            this.courseLabsLoaded = true;
        },
        async createLabForCourse() {
            this.createLabForCourseButton = false;
            this.fetchData = true;
            const url = this.$store.getters.getAPIKey.mainAPI + `/labactivities`;
            await axios
                .post(url, {
                    course_id: this.course_id,
                })
                .then(() => {
                    this.getCourseLabs();
                    // this.fetchData = false;
                })
                .catch(() => {
                    this.$toast.error("Failed to initiate lab, Please try again", {
                        position: "top",
                        duration: 3000,
                    });
                    this.fetchData = false;
                });
        },
        async getLabEvaluationOptions() {
            const url =
                this.$store.getters.getAPIKey.mainAPI +
                `/labevaluationheaders?course=${this.course_id}`;

            const response = await axios.get(url);
            const labevaluationheaders = response.data;

            this.courseLabs.forEach((lab) => {
                labevaluationheaders.forEach((header) => {
                    if (header.lab_activity_id !== lab.id) return;

                    const option = this.labEvaluationOptions[lab.type]?.[header.name];

                    // 🔐 CRITICAL GUARD (prevents crash)
                    if (!option) {
                        console.warn(
                            `Header "${header.name}" not found in labEvaluationOptions for type "${lab.type}"`
                        );
                        return;
                    }

                    option.score = header.maximum_mark;
                    option.id = header.id;
                    option.no = header.no;
                    option.enable = true;

                    // enable flags
                    if (lab.type === "lab") this.enableLabAssessmentEvaluation = true;
                    else if (lab.type === "internal_exam") this.enableLabInternalExamEvaluation = true;
                    else if (lab.type === "record") this.enableLabRecordEvaluation = true;
                    else this.enableLabVivaVoceEvaluation = true;
                });
            });
        },

        async updateLabEvaluationOptions(courseLabType, labId) {
            if (courseLabType == "lab") {
                this.enableLabAssessmentEvaluation = false;
            } else if (courseLabType == "internal_exam") {
                this.enableLabInternalExamEvaluation = false;
            } else if (courseLabType == "record") {
                this.enableLabRecordEvaluation = false;
            } else {
                // viva voce
                this.enableLabVivaVoceEvaluation = false;
            }
            const url =
                this.$store.getters.getAPIKey.mainAPI + `/labevaluationheaders`;
            var postData = [];

            for (var headerKey in this.labEvaluationOptions[courseLabType]) {
                // console.log(this.labEvaluationOptions[courseLabType][headerKey]);
                if (this.labEvaluationOptions[courseLabType][headerKey].enable) {
                    if (courseLabType == "lab") {
                        this.enableLabAssessmentEvaluation = true;
                    } else if (courseLabType == "internal_exam") {
                        this.enableLabInternalExamEvaluation = true;
                    } else if (courseLabType == "record") {
                        this.enableLabRecordEvaluation = true;
                    } else {
                        // viva_voce
                        this.enableLabVivaVoceEvaluation = true;
                    }
                    if (
                        this.labEvaluationOptions[courseLabType][headerKey].score == "" ||
                        this.labEvaluationOptions[courseLabType][headerKey].no == ""
                    ) {
                        this.$toast.error("Please fill all enabled fields", {
                            position: "top",
                            duration: 3000,
                        });
                    }

                    postData.push({
                        maximum_mark: this.labEvaluationOptions[courseLabType][headerKey]
                            .score,
                        lab_activity_id: labId,
                        name: headerKey,
                        no: this.labEvaluationOptions[courseLabType][headerKey].no,
                    });
                }
            }
            await axios
                .post(url, { labHeaders: postData, lab_activity_id: labId })
                .then((response) => {
                    response;

                })
                .catch(() => {
                    this.$toast.error(
                        "Failed to update/ you cannot delete if Score is already added",
                        {
                            position: "top",
                            duration: 5000,
                        }
                    );
                    this.fetchData = false;
                });
            await this.getLabEvaluationOptions();
            this.editLabHeaders = false;
        },
        async getLabExperiments() {
            const url =
                this.$store.getters.getAPIKey.mainAPI +
                `/labexperiments?course=${this.course_id}`;
            await axios.get(url).then((response) => {
                this.labExperiments = response.data;
            });
        },



        closelabEvaluationModel() {
            this.$bvModal.hide("labEvaluationModel");
        },
        async labEvaluationTable(labActivity) {
            if (labActivity.type == "internal_exam") {
                this.labInternalExamEvaluationType = 'single_experiment';
            } else {
                this.labInternalExamEvaluationType = 'multiple_experiments';
            }
            this.evaluationLabActivity = labActivity;
            this.evaluationTableHeaderRow = [];
            this.enabledLabHeaders = [];
            this.evaluationTableDates = {};
            // for evaluation we need student list, experiment list, header list
            if (this.students.length == 0) await this.fetchCourseStudents();
            for (var labHeaderKey in this.labEvaluationOptions[labActivity.type]) {
                if (this.labEvaluationOptions[labActivity.type][labHeaderKey].enable) {
                    this.enabledLabHeaders.push(
                        this.labEvaluationOptions[labActivity.type][labHeaderKey]
                    );
                }
            }
            this.labExperiments.forEach((exp) => {
                let sum = 0;
                for (var labHeaderKey in this.labEvaluationOptions[labActivity.type]) {
                    if (
                        this.labEvaluationOptions[labActivity.type][labHeaderKey].enable
                    ) {
                        sum = Number(sum) + Number(this.labEvaluationOptions[labActivity.type][
                            labHeaderKey
                        ].score);
                        this.evaluationTableHeaderRow.push({
                            id: this.labEvaluationOptions[labActivity.type][labHeaderKey].id,
                            name: labHeaderKey,
                            experiment_id: exp.id,
                            max_score: this.labEvaluationOptions[labActivity.type][
                                labHeaderKey
                            ].score,
                            type: null
                        });
                    }
                }
                this.evaluationTableHeaderRow.push({
                    id: null,
                    name: 'Total',
                    experiment_id: exp.id,
                    max_score: sum,
                    type: 'total'
                });
                this.evaluationTableHeaderRow.push({
                    id: null,
                    name: null,
                    experiment_id: exp.id,
                    max_score: null,
                    type: 'date'
                });
            });

            this.students.forEach((student) => {
                this.evaluationTableData[student.institution_user_id] = {};
                Vue.set(this.totalScores, student.institution_user_id, {});
                Vue.set(this.avarage, student.institution_user_id, {});
                this.evaluationTableHeaderRow.forEach((evaluationHeader) => {
                    if (evaluationHeader.type == 'date') {
                        if (!(student.institution_user_id in this.evaluationTableDates)) this.$set(this.evaluationTableDates, student.institution_user_id, {});
                        if (!(evaluationHeader.experiment_id in this.evaluationTableDates[student.institution_user_id])) this.$set(this.evaluationTableDates[student.institution_user_id], evaluationHeader.experiment_id, null);
                    }
                    else {
                        if (!(
                            evaluationHeader.experiment_id in
                            this.evaluationTableData[student.institution_user_id]
                        ))
                            this.evaluationTableData[student.institution_user_id][
                                evaluationHeader.experiment_id
                            ] = {};
                        this.evaluationTableData[student.institution_user_id][
                            evaluationHeader.experiment_id
                        ][evaluationHeader.id] = null;
                        Vue.set(this.totalScores[student.institution_user_id], evaluationHeader.experiment_id, null);
                    }
                });
            });
            // this.$forceUpdate();
            //this.$bvModal.show("labEvaluationModel");
            const url =
                this.$store.getters.getAPIKey.mainAPI +
                `/labevaluations?labActivity=${labActivity.id}`;
            await axios.get(url).then((response) => {
                let multipleExperimentEvaluation = null;
                response.data.evaluations.forEach((evaluation) => {
                    if (this.evaluationLabActivity.type == "internal_exam") {
                        if (multipleExperimentEvaluation != null && multipleExperimentEvaluation != evaluation.experiment_id) {
                            this.labInternalExamEvaluationType = 'multiple_experiments';
                        }
                    }
                    // console.log(evaluation);
                    if (evaluation.student_id in this.evaluationTableData)
                        this.evaluationTableData[evaluation.student_id][
                            evaluation.experiment_id
                        ][evaluation.header_id] = parseFloat(evaluation.score);
                    this.updateTotalMarks(evaluation.student_id, evaluation.experiment_id);
                    multipleExperimentEvaluation = evaluation.experiment_id;
                });
                response.data.dates.forEach((date) => {
                    if (date.student_id in this.evaluationTableDates)
                        this.evaluationTableDates[date.student_id][
                            date.experiment_id
                        ] = date.date;
                });

            });
            this.$forceUpdate();
        },

        async updateLabEvaluation(autoUpdateEvent = false) {
            var postData = [];
            for (const studkey in this.evaluationTableData) {
                for (const expdkey in this.evaluationTableData[studkey]) {
                    for (const headdkey in this.evaluationTableData[studkey][expdkey]) {
                        let score = this.evaluationTableData[studkey][expdkey][headdkey];
                        if (score !== null) {
                            postData.push({
                                score: score,
                                course_id: this.course_id,
                                student_id: studkey,
                                lab_activity_id: this.evaluationLabActivity.id,
                                experiment_id: expdkey,
                                header_id: headdkey,
                            });
                        }
                    }
                }
            }
            let experimentDates = [];
            for (const studkey in this.evaluationTableDates) {
                for (const expdkey in this.evaluationTableDates[studkey]) {
                    let date = this.evaluationTableDates[studkey][expdkey];
                    if (date != null && date != '') {
                        experimentDates.push({
                            date: date,
                            student_id: studkey,
                            lab_activity_id: this.evaluationLabActivity.id,
                            experiment_id: expdkey,
                        });
                    }
                }
            }
            const url = this.$store.getters.getAPIKey.mainAPI + `/labevaluations`;
            await axios
                .post(url, { labEvaluations: postData, experiment_dates: experimentDates })
                .then(() => {
                    // this.getLabExperiments();
                    // this.fetchData = false;
                })
                .catch(() => {
                    this.$toast.error("Failed to create", {
                        position: "top",
                        duration: 3000,
                    });
                    this.fetchData = false;
                });
            if (autoUpdateEvent) {
                this.$toast.success("Score updated automatically.");
            }
            else {
                this.$toast.success("Score Upation Successfully done.");
                //this.$bvModal.hide("labEvaluationModel");
            }
        },
        async fetchCourseStudents() {
            let mainUrl = this.$store.getters.getAPIKey.createStudent;
            const url = mainUrl.replace("course_id", this.course_id)+ '?sortBy=lab';
            await this.$axios.get(url).then((response) => {
                this.students = [];
                this.students = response.data.users ?? response.data[0] ?? [];
            this.studentListOrder = response.data.student_list_order || 'roll_number';
            });
        },
    },
};
</script>

<style>
.update-score-wrapper {
    padding: 15px;
}

.update-score-wrapper.edit-mode {
    position: fixed;
    inset: 0;
    background: #f8f9fa;
    z-index: 1050;
    overflow: auto;
}
</style>
